import { useNavigate } from "react-router-dom";
type Tab = "home" | "menu" | "orders" | "payment" | "profile";

interface Props {
  active: Tab;
  tableNo?: string;
}

const HomeIcon = ({ active }: { active?: boolean }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 11l9-8 9 8v9a2 2 0 01-2 2h-4v-7H9v7H5a2 2 0 01-2-2v-9z" stroke={active ? "#F15A29" : "rgba(17,17,17,0.6)"} strokeWidth="2" strokeLinejoin="round" />
  </svg>
);

const MenuIcon = ({ active }: { active?: boolean }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M4 4h12a3 3 0 013 3v13H7a3 3 0 01-3-3V4zM4 4v13M19 7H8" stroke={active ? "#F15A29" : "rgba(17,17,17,0.6)"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const OrdersIcon = ({ active }: { active?: boolean }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="5" y="3" width="14" height="18" rx="2" stroke={active ? "#F15A29" : "rgba(17,17,17,0.6)"} strokeWidth="2" />
    <path d="M8 8h8M8 12h8M8 16h5" stroke={active ? "#F15A29" : "rgba(17,17,17,0.6)"} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const PaymentIcon = ({ active }: { active?: boolean }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="6" width="18" height="13" rx="2" stroke={active ? "#F15A29" : "rgba(17,17,17,0.6)"} strokeWidth="2" />
    <path d="M3 11h18" stroke={active ? "#F15A29" : "rgba(17,17,17,0.6)"} strokeWidth="2" />
  </svg>
);

const ProfileIcon = ({ active }: { active?: boolean }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="8" r="4" stroke={active ? "#F15A29" : "rgba(17,17,17,0.6)"} strokeWidth="2" />
    <path d="M4 20c1.5-3.5 5-5 8-5s6.5 1.5 8 5" stroke={active ? "#F15A29" : "rgba(17,17,17,0.6)"} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const NavItem = ({ icon, label, active, onClick, disabled }: { icon: React.ReactNode; label: string; active?: boolean; onClick?: () => void; disabled?: boolean }) => (
  <button
    type="button"
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
    className="flex-1 flex flex-col items-center justify-center gap-1 bg-transparent border-0 disabled:opacity-40 disabled:cursor-not-allowed"
  >
    {icon}
    <span className={`font-opensans text-[12px] ${active ? "font-bold text-[#F15A29]" : "font-normal text-[rgba(17,17,17,0.6)]"}`}>
      {label}
    </span>
  </button>
);

const BottomNav = ({ active, tableNo }: Props) => {
  const navigate = useNavigate();
  const menuPath = tableNo ? `/mobile/menu/${tableNo}` : "/mobile/menu";
  const isMenu = active === "menu";

  return (
    <>
      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full bg-white shadow-[0_-4px_10px_rgba(0,0,0,0.08)] flex items-stretch h-[70px] z-40">
        <NavItem
          icon={<HomeIcon active={active === "home"} />}
          label="Home"
          active={active === "home"}
          onClick={() => navigate("/mobile/tables")}
        />
        <NavItem
          icon={<OrdersIcon active={active === "orders"} />}
          label="Orders"
          active={active === "orders"}
          onClick={() => navigate("/mobile/orders")}
        />

        {/* Center Menu FAB */}
        <div className="flex-1 relative flex items-start justify-center">
          <button
            type="button"
            onClick={() => navigate(menuPath)}
            className="absolute -top-6 w-[64px] h-[64px] rounded-full flex flex-col items-center justify-center border-4 border-white shadow-[0_4px_12px_rgba(0,0,0,0.18)]"
            style={{ backgroundColor: "#F15A29" }}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <path d="M12 4v2" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
              <path d="M4 18c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M3 18h18" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
          <span className={`absolute bottom-2 font-opensans text-[12px] ${isMenu ? "font-bold text-[#F15A29]" : "font-normal text-[rgba(17,17,17,0.6)]"}`}>
            Menu
          </span>
        </div>

        <NavItem
          icon={<PaymentIcon active={active === "payment"} />}
          label="Payment"
          active={active === "payment"}
          onClick={() => navigate("/mobile/payment")}
          disabled={true}
        />
        <NavItem
          icon={<ProfileIcon active={active === "profile"} />}
          label="Profile"
          active={active === "profile"}
          onClick={() => navigate("/mobile/profile")}
        />
      </div>
    </>
  );
};

export default BottomNav;
